module.exports = __webpack_public_path__ + "assets/chooseSmsGateway.ce7eef8c.svg";